/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_AssigneeInputs */

const en_qk_assignee = /** @type {(inputs: Qk_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person, me or none`)
};

const de_qk_assignee = /** @type {(inputs: Qk_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person, me oder none`)
};

/**
* | output |
* | --- |
* | "Person, me or none" |
*
* @param {Qk_AssigneeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_assignee = /** @type {((inputs?: Qk_AssigneeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_AssigneeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_assignee(inputs)
	return en_qk_assignee(inputs)
});